/**
 * Magicstar Theme — Product Form JS
 *
 * Handles variant selection, price updates, and Add to Cart on the PDP.
 * Uses Shopify AJAX Cart API for cart adds — NOT a custom cart.
 *
 * Tracking note:
 *   AddToCart is fired in cart-drawer.js after /cart/add.js confirms success.
 *   This file only handles UI: variant switching + ATC button state.
 */

(function () {
  'use strict';

  var forms = document.querySelectorAll('[data-product-id]');
  var productJsonCache = {};

  forms.forEach(function (form) {
    var productId = form.getAttribute('data-product-id');
    if (!productId) return;

    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('.quantity-selector__input');
    var qtyMinus = form.querySelector('.quantity-selector__btn--minus');
    var qtyPlus = form.querySelector('.quantity-selector__btn--plus');
    var atcBtn = form.querySelector('.product-info__atc');
    var buyNowBtn = form.querySelector('.product-info__buy-now');
    var sectionEl = form.closest('[data-section-id]');
    var sectionId = sectionEl ? sectionEl.getAttribute('data-section-id') : null;
    var priceWrap = sectionId ? document.getElementById('product-price-' + sectionId) : null;
    var stockWrap = sectionId ? document.getElementById('product-stock-' + sectionId) : null;
    var galleryEl = sectionId ? document.getElementById('product-gallery-' + sectionId) : null;
    var mobileAtcBtn = sectionId ? document.getElementById('mobile-atc-btn-' + sectionId) : null;

    // ── Quantity controls ──────────────────────────────────────────────────

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10);
        qtyInput.value = v + 1;
      });
    }

    // ── Variant selection ──────────────────────────────────────────────────

    var radioInputs = form.querySelectorAll('.product-option__radio');
    radioInputs.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // Update selected label display
        var optionWrapper = radio.closest('[data-option-index]');
        if (optionWrapper) {
          var selectedDisplay = document.getElementById('option-selected-' + (parseInt(optionWrapper.getAttribute('data-option-index'), 10) + 1));
          if (selectedDisplay) selectedDisplay.textContent = radio.value;
        }
        // Highlight selected btn
        var siblings = radio.closest('.product-option__values').querySelectorAll('.product-option__value-btn');
        siblings.forEach(function (s) { s.classList.remove('is-selected'); });
        radio.nextElementSibling && radio.nextElementSibling.classList.add('is-selected');

        // Find matching variant
        updateVariantFromSelections(form, variantInput, atcBtn, buyNowBtn, priceWrap, stockWrap, galleryEl, mobileAtcBtn);
      });
    });

    // ── Add to Cart ────────────────────────────────────────────────────────

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) return;

        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        var productTitle = form.getAttribute('data-product-title');
        var price = parseInt(form.getAttribute('data-price'), 10) || 0;

        if (atcBtn) {
          atcBtn.classList.add('btn--loading');
          atcBtn.setAttribute('disabled', '');
        }

        window.addToCart(variantId, qty, productTitle, price)
          .then(function () {
            if (atcBtn) {
              atcBtn.classList.remove('btn--loading');
              atcBtn.removeAttribute('disabled');
              // Briefly show "Added!" state
              var span = atcBtn.querySelector('span:not(.btn__spinner)');
              if (span) {
                var original = span.textContent;
                span.textContent = 'Added! ✓';
                setTimeout(function () { span.textContent = original; }, 1500);
              }
            }
            window.showCartToast && window.showCartToast('✓ Added to cart');
            window.openCartDrawer && window.openCartDrawer();
          })
          .catch(function (err) {
            if (atcBtn) {
              atcBtn.classList.remove('btn--loading');
              atcBtn.removeAttribute('disabled');
            }
            window.showCartToast && window.showCartToast('Something went wrong. Please try again.');
            console.error('[Product Form] Add to cart failed:', err);
          });
      });
    }

    // ── Buy Now ────────────────────────────────────────────────────────────

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) return;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        var productTitle = form.getAttribute('data-product-title');
        var price = parseInt(form.getAttribute('data-price'), 10) || 0;

        buyNowBtn.classList.add('btn--loading');
        buyNowBtn.setAttribute('disabled', '');

        window.addToCart(variantId, qty, productTitle, price)
          .then(function () {
            // Use Shopify routes.checkout from body data attribute — avoids hardcoded URL
            var checkoutUrl = document.body.getAttribute('data-checkout-url') || '/checkout';
            redirectToCheckout(checkoutUrl);
          })
          .catch(function (err) {
            buyNowBtn.classList.remove('btn--loading');
            buyNowBtn.removeAttribute('disabled');
            console.error('[Product Form] Buy Now failed:', err);
          });
      });
    }

    // ── Gallery ────────────────────────────────────────────────────────────

    if (galleryEl) {
      var thumbs = galleryEl.querySelectorAll('.product-gallery__thumb');
      var slides = galleryEl.querySelectorAll('.product-gallery__slide');
      var prevBtn = galleryEl.querySelector('.product-gallery__nav--prev');
      var nextBtn = galleryEl.querySelector('.product-gallery__nav--next');
      var currentSlide = 0;

      function showSlide(idx) {
        currentSlide = idx;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { showSlide(i); });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          showSlide(currentSlide > 0 ? currentSlide - 1 : slides.length - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          showSlide(currentSlide < slides.length - 1 ? currentSlide + 1 : 0);
        });
      }

      // Touch/swipe support
      var touchStartX = 0;
      galleryEl.querySelector('.product-gallery__main') && galleryEl.querySelector('.product-gallery__main').addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      galleryEl.querySelector('.product-gallery__main') && galleryEl.querySelector('.product-gallery__main').addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            showSlide(currentSlide < slides.length - 1 ? currentSlide + 1 : 0);
          } else {
            showSlide(currentSlide > 0 ? currentSlide - 1 : slides.length - 1);
          }
        }
      }, { passive: true });
    }
  });

  // ── Variant matching ─────────────────────────────────────────────────────

  function updateVariantFromSelections(form, variantInput, atcBtn, buyNowBtn, priceWrap, stockWrap, galleryEl, mobileAtcBtn) {
    // Build current selections object
    var selected = {};
    form.querySelectorAll('[data-option-index]').forEach(function (wrapper) {
      var idx = wrapper.getAttribute('data-option-index');
      var checked = wrapper.querySelector('.product-option__radio:checked');
      if (checked) selected[idx] = checked.value;
    });

    // Fetch product JSON to find matching variant
    var handle = form.getAttribute('data-product-handle');
    if (!handle) return;

    getProductJson(handle)
      .then(function (product) {
        var variant = product.variants.find(function (v) {
          for (var i = 0; i < product.options.length; i++) {
            if (v['option' + (i + 1)] !== selected[String(i)]) return false;
          }
          return true;
        });

        if (!variant) return;

        // Update hidden variant input
        if (variantInput) variantInput.value = variant.id;
        // Update form data attributes for cart tracking
        form.setAttribute('data-variant-id', variant.id);
        form.setAttribute('data-price', variant.price);

        // Update price display
        if (priceWrap) {
          var price = formatMoney(variant.price);
          var compareAt = variant.compare_at_price > variant.price;
          var savingsAmt = compareAt ? variant.compare_at_price - variant.price : 0;
          var savingsPct = compareAt ? Math.round((savingsAmt / variant.compare_at_price) * 100) : 0;
          priceWrap.innerHTML = '<div class="price-wrap' + (compareAt ? ' price-wrap--on-sale' : '') + '">' +
            '<span class="price price--current">' + price + '</span>' +
            (compareAt ? '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span>' : '') +
            '</div>' +
            (compareAt ? '<div class="price-savings-badge">🔥 ' + savingsPct + '% OFF &mdash; SAVE ' + formatMoney(savingsAmt) + '</div>' : '') +
            '<p class="product-info__tax-note">Taxes included. Shipping calculated at checkout.</p>';
        }

        if (stockWrap) {
          stockWrap.innerHTML = variant.available
            ? '<span class="product-info__stock-badge product-info__stock-badge--in">In Stock</span><span class="product-info__stock-text product-info__delivery-est" id="delivery-est-' + (form.closest('[data-section-id]') ? form.closest('[data-section-id]').getAttribute('data-section-id') : '') + '">🚚 Calculating delivery time…</span>'
            : '<span class="product-info__stock-badge product-info__stock-badge--out">Sold Out</span><span class="product-info__stock-text">Select another option or message us for help.</span>';
        }

        // Update CTA availability
        [atcBtn, buyNowBtn, mobileAtcBtn].forEach(function (btn) {
          if (!btn) return;
          var label = btn.querySelector('span:not(.btn__spinner)');
          if (variant.available) {
            btn.removeAttribute('disabled');
            btn.classList.remove('is-disabled');
            if (btn === atcBtn && label) label.textContent = 'Add to Cart';
            if (btn === mobileAtcBtn) btn.innerHTML = renderMobileAtcLabel('Add to Cart');
            if (btn === buyNowBtn) btn.textContent = 'Buy It Now';
          } else {
            btn.setAttribute('disabled', '');
            btn.classList.add('is-disabled');
            if (btn === atcBtn && label) label.textContent = 'Sold Out';
            if (btn === mobileAtcBtn) btn.innerHTML = renderMobileAtcLabel('Sold Out');
            if (btn === buyNowBtn) btn.textContent = 'Sold Out';
          }
        });

        // Update gallery to show variant image
        if (variant.featured_image && galleryEl) {
          var slides = galleryEl.querySelectorAll('.product-gallery__slide');
          var thumbs = galleryEl.querySelectorAll('.product-gallery__thumb');
          var featuredSrc = normalizeImageUrl(variant.featured_image.src || variant.featured_image.url || '');

          slides.forEach(function (slide, i) {
            var img = slide.querySelector('img');
            if (!img) return;
            if (normalizeImageUrl(img.src) === featuredSrc) {
              slides.forEach(function (s, j) {
                s.classList.toggle('is-active', j === i);
                if (thumbs[j]) thumbs[j].classList.toggle('is-active', j === i);
              });
            }
          });
        }

        // Update page URL (without reload)
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      })
      .catch(function (err) {
        console.error('[Product Form] Variant fetch failed:', err);
      });
  }

  function renderMobileAtcLabel(text) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' + text;
  }

  function redirectToCheckout(url) {
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = url;
        return;
      }
    } catch (e) {}
    window.location.href = url;
  }

  function formatMoney(cents) {
    cents = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    return 'Dhs. ' + (cents / 100).toFixed(2);
  }

  function getProductJson(handle) {
    if (!productJsonCache[handle]) {
      productJsonCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
    }
    return productJsonCache[handle];
  }

  function normalizeImageUrl(src) {
    return String(src || '').split('?')[0].replace(/^https?:/, '');
  }

})();
